import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  searchBox: {
    marginBottom: '1rem'
  },
  sourceSelectionTable: {
    '& tbody tr': {
      gap: '0',
      padding: '0'
    }
  },
  sourceList: {
    maxHeight: '25rem',
    minHeight: '25rem',
    overflowY: 'auto',
    border: `1px solid ${theme.vars.palette.divider}`,
    borderRadius: '0.25rem'
  },
  headerRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 2fr 2fr',
    gap: '1rem',
    padding: '0.5rem 1rem',
    // backgroundColor: theme.palette.background.elevation1,
    // backgroundColor:'var(--mui-palette-background-elevation3)',
    backgroundColor: 'var(--ag-background-color)',
    borderBottom: `2px solid ${theme.palette.divider}`,
    position: 'sticky',
    top: 0,
    zIndex: 1
  },
  headerCell: {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: theme.vars.palette.text.primary,
    width: '33.33%',
    padding: '.75rem 1rem'
  },
  sourceRow: {
    // display: 'grid',
    // gridTemplateColumns: '1fr 2fr 2fr',
    // gap: '1rem',
    // padding: '0.5rem 1rem',
    cursor: 'pointer',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.divider}`,
    transition: 'background-color 0.2s',
    color: theme.vars.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.vars.palette.action.hover
    },
    '&.selected': {
      backgroundColor: theme.vars.palette.primary.main,
      color: theme.vars.palette.text.contrast
    },
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  sourceCell: {
    fontSize: '0.875rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '33.33%',
    color: 'unset',
    padding: '.75rem 1rem'
  },
  emptyState: {
    padding: '2rem',
    textAlign: 'center',
    color: theme.vars.palette.text.secondary
  }
}));

export default useStyles;
